import { render, staticRenderFns } from "./profileFriends.vue?vue&type=template&id=025e354f&scoped=true&"
import script from "./profileFriends.vue?vue&type=script&lang=js&"
export * from "./profileFriends.vue?vue&type=script&lang=js&"
import style0 from "./profileFriends.vue?vue&type=style&index=0&id=025e354f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e354f",
  null
  
)

export default component.exports